import { createContext, useContext, useState, ReactNode } from 'react';
import { LearningMetric } from '@/data/learningContent';

interface LearningContextType {
  isDrawerOpen: boolean;
  activeMetric: LearningMetric | null;
  openMetric: (metric: LearningMetric) => void;
  closeDrawer: () => void;
}

const LearningContext = createContext<LearningContextType | undefined>(undefined);

export function LearningProvider({ children }: { children: ReactNode }) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [activeMetric, setActiveMetric] = useState<LearningMetric | null>(null);

  const openMetric = (metric: LearningMetric) => {
    setActiveMetric(metric);
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    // Keep activeMetric for animation purposes, clear after close
    setTimeout(() => setActiveMetric(null), 300);
  };

  return (
    <LearningContext.Provider value={{ isDrawerOpen, activeMetric, openMetric, closeDrawer }}>
      {children}
    </LearningContext.Provider>
  );
}

export function useLearning() {
  const context = useContext(LearningContext);
  if (!context) {
    throw new Error('useLearning must be used within a LearningProvider');
  }
  return context;
}
